import { PrimaryIconButton } from "components";
import { Check } from "@material-ui/icons";

const PrimaryCheckButton = ({
  onClick,
  tooltipTitle,
  disabled,
  loading,
  ...rest
}) => {
  return (
    <PrimaryIconButton
      icon={<Check />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryCheckButton;
